module.exports = __webpack_public_path__ + "static/media/ECOSUP-SANTE.1daaa7d5.png";